import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import {userService} from "../../../services/UserService";
import 'leaflet/dist/leaflet.css';
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import Mapa from "./Mapa";
import Draggable from 'react-draggable';
import {ArrowLeft, ArrowRight} from "@material-ui/icons";
import {IParcela} from "../../../types";
import MenuVisualizador from "./MenuVisualizador";
import {Typography} from "@material-ui/core";

const config = require('../../../config.json');


interface IProps {
    zonificacion_selected: string
    zonas_scale: Record<number, (number[] | string)[]>
    setZonasScale(zonas_scale: Record<number, (number[] | string)[]>): void
}

interface Istate {
    show: boolean
}


class LeyendaZonif extends React.Component<IProps, Istate> {

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.zonificacion_selected !== nextProps.zonificacion_selected) {
            if (nextProps.zonificacion_selected.length !== 0) {
                const fuente = nextProps.zonificacion_selected.split(',')[0]
                const parcela = nextProps.zonificacion_selected.split(',')[1]
                const fecha = nextProps.zonificacion_selected.split(',')[2]
                const indice = nextProps.zonificacion_selected.split(',')[3]
                const nombre = nextProps.zonificacion_selected.split(',')[4]

                axios.get(
                    config.url+`/static/visualizador/zonificaciones/${userService.getUser()}/${fuente}/${parcela}/${fecha}/${indice}/${nombre}/info.json`,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }}
                )
                    .then((res) => {
                        this.props.setZonasScale(res.data)
                        this.setState({show: true})
                    })
                    .catch(() => {})
            } else {
                this.setState({show: false})
                this.props.setZonasScale({})
            }

        }
        return true
    }

    state:Istate = {
        show: false
    }

    render() {
        if (this.state.show) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 70,
                        height: '20%',
                        marginLeft: '-10%',
                        marginTop: '5%',
                        backgroundColor: "rgba(255,255,255,0.8)",
                        zIndex: 200,
                        alignItems: "center",
                        borderRadius: 12,
                        borderStyle: "solid",
                        borderWidth:2,
                        borderColor: "rgba(255,255,255,0.6)"
                    }}
                >

                    {Object.keys(this.props.zonas_scale).reverse().map((i) =>
                        <div
                            key={i}
                            style={{
                                display: "flex",
                                flexDirection: 'row',
                                width: '100%',
                                height: `${100/Object.keys(this.props.zonas_scale).length}%`,
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <div
                                key={i}
                                style={{
                                    height: 20,
                                    width: 20,
                                    backgroundColor: this.props.zonas_scale[parseInt(i)][0] as string,
                                    borderRadius: 20,
                                    marginLeft: 5
                                }}
                            />
                            <Typography
                                style={{
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    marginRight: 5
                                }}
                            >
                                {this.props.zonificacion_selected.split(',')[3] === 'lst' ?
                                    Math.round(10*(parseFloat(this.props.zonas_scale[parseInt(i)][1][0] as string) + parseFloat(this.props.zonas_scale[parseInt(i)][1][1] as string))/2)/10
                                    :
                                    this.props.zonificacion_selected.split(',')[3] === 'dsm' ?
                                        Math.round((parseFloat(this.props.zonas_scale[parseInt(i)][1][0] as string) + parseFloat(this.props.zonas_scale[parseInt(i)][1][1] as string))/2)
                                        :
                                        Math.round(100*(parseFloat(this.props.zonas_scale[parseInt(i)][1][0] as string) + parseFloat(this.props.zonas_scale[parseInt(i)][1][1] as string))/2)/100
                                }

                            </Typography>
                        </div>
                    )}
                </div>
            )
        } else {
            return null
        }
    }
}

const mapStateToProps = (state: IStore) => ({
    zonificacion_selected: state.visualizador.zonificacion_selected,
    zonas_scale: state.visualizador.zonas_scale,
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setZonasScale: (zonas_scale: Record<number, (number[] | string)[]>) => dispatch({type: "set-visualizador-zonas-scale", zonas_scale})
});

export default connect(mapStateToProps, mapDispatchToProps)(LeyendaZonif);
